import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { ReactHTML_instanceofb06f385x0w as ReactHTML_instance } from '../../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { encodeToByteArray1onwao0uakjfh as encodeToByteArray } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { toHexString5bhtjxqec7ow as toHexString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/HexExtensions.mjs';
import { MD5s71ietnk13uj as MD5 } from '../../../../../../../hash-library-md/org/kotlincrypto/hash/md/MD5.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_md5() {
  _init_properties_GravatarImage_kt__i0dolh();
  return md5;
}
var md5;
function gravatarImage(_this__u8e3s4, email, fallback, className, alt, options) {
  fallback = fallback === VOID ? null : fallback;
  className = className === VOID ? null : className;
  _init_properties_GravatarImage_kt__i0dolh();
  setDefaultKey(_this__u8e3s4, '@rdk/30_14');
  // Inline function 'react.dom.html.ReactHTML.img' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$img) => {
    $this$img.src = myGravatarUrl(options, email, fallback);
    $this$img.alt = alt;
    $this$img.draggable = false;
    $this$img.width = options.size;
    $this$img.height = options.size;
    if (className == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$img.className = className;
    }
    return Unit_instance;
  };
  addChild(_this__u8e3s4, 'img', block);
  return Unit_instance;
}
function myGravatarUrl(options, email, fallback) {
  _init_properties_GravatarImage_kt__i0dolh();
  var tmp;
  if (email == null && !(fallback == null)) {
    tmp = fallback;
  } else {
    tmp = gravatarUrl(email == null ? '' : email, options);
  }
  return tmp;
}
function gravatarUrl(email, options) {
  _init_properties_GravatarImage_kt__i0dolh();
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.text.trim' call
  var this_0 = email.toLowerCase();
  var tmp$ret$2 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var codedEmail = md5_0(tmp$ret$2);
  return 'https://www.gravatar.com/avatar/' + codedEmail + '?default=' + options.default + '&s=' + options.size;
}
function md5_0(value) {
  _init_properties_GravatarImage_kt__i0dolh();
  return toHexString(get_md5().p3n(encodeToByteArray(value)));
}
var properties_initialized_GravatarImage_kt_fp2kw7;
function _init_properties_GravatarImage_kt__i0dolh() {
  if (!properties_initialized_GravatarImage_kt_fp2kw7) {
    properties_initialized_GravatarImage_kt_fp2kw7 = true;
    md5 = MD5().j3p();
  }
}
//region block: exports
export {
  gravatarImage as gravatarImage1br855ijy5dqm,
  gravatarUrl as gravatarUrl2z6ne5pwiaaxt,
  myGravatarUrl as myGravatarUrlsjogkf8vm6pg,
};
//endregion

//# sourceMappingURL=GravatarImage.mjs.map
